import { useEffect, useState } from 'react';
import axios from 'axios';
import style from './register.module.css'
import UploadPhotoBig from '../../img/addphoto.png'
import { useAuthLocalStorage } from '../../modules/useLocalStore';

function ModeratedPhoto({myProfile , setMyProfile, ThisIsLoad,socketRef}){

    
    const { getToken, removeToken } = useAuthLocalStorage();
    
    const token = getToken();
    const handleImageUpload = (e, index) => {
        const file = e.target.files[0];
        handleUpBD(file);
       
    };
   
    const handleUpBD = (image) => {
        if(token !== null)
        {
            
            const formData = new FormData();
            formData.append('image', image);
            
            const config = {
                headers: {
                    Authorization: "Bearer " + token,
                    'Content-Type': 'multipart/form-data'
                }
            };

            axios.post(`https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/addPhoto`, formData,config)
            .then(response => {
                var fileid = response.data.id_file;
                const updatedProfile = {...myProfile};
                updatedProfile.photo.push({ id: fileid, moderated: 0});
                setMyProfile(updatedProfile);
            })
            .catch(error => {
                console.error('Error uploading image:', error);
            });
        }
    };
    return(
        <div className={style.flexblock}>
            <div className={style.leftcontent + ' ' + style.wsto}>
            <h1>Регистрация прошла успешно!</h1>
            <div className={style.photoflex}>
                <div className={style.flexdivph}>
               
                    {myProfile.photo && myProfile.photo.length > 0 ? (
                        
                        <img src={`https://winxy.ru/static_img.php?id=${myProfile.photo.find(item => item.id >= 1).id}`} alt={`Uploaded`} style={{ maxWidth: 200, maxHeight: 200 }} />
                    ) : (
                        <>
                        <label htmlFor={`upload-image`}>
                            <img src={UploadPhotoBig} alt="Upload" style={{ cursor: 'pointer', maxWidth: 200, maxHeight: 200 }} />
                        </label>
                        <input
                            type="file"
                            id={`upload-image`}
                            accept="image/*"
                            onChange={(e) => handleImageUpload(e)}
                            style={{ display: 'none' }}
                        />
                        </>
                    )}
                </div>
                <div className={style.contentph}>
                    <div className={style.flexoblakotop}>
                        {myProfile.photo && myProfile.photo.length > 0 ? <h5>Фото проходит модерацию</h5> : <h5>Загрузи свое фото</h5>}
                        <h2>🫶</h2>
                    </div>
                    {myProfile.photo && myProfile.photo.length > 0 ? <h6>Обычно фотография проверяется в течении 30 секунд. </h6> : <h6>Загрузи хотя бы одну фотографию, все фотографии проверяются! </h6> }
    
                    {myProfile.photo && myProfile.photo.length > 0 ? <h4>Страница закроется автоматически</h4> : <h4>Чтобы выполнить загрузку необходимо нажать на изображение</h4> }
                  
                </div>
            </div>
            </div>
                        
            
            
        </div>
     );
}
export default ModeratedPhoto;